import { Backdrop, CircularProgress } from "@mui/material";
import { useFormContext } from "react-hook-form";

const Index = () => {
  const { getValues, setValue } = useFormContext();
  const loading = getValues("loading");
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Index;
